var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 18.9199C14.3984 18.9206 14.2679 18.8954 14.1461 18.8456C14.0242 18.7959 13.9134 18.7225 13.82 18.6299L7.88999 12.7099C7.70726 12.5182 7.60368 12.2646 7.59999 11.9999C7.59923 11.8682 7.62446 11.7378 7.67422 11.6159C7.72399 11.4941 7.79731 11.3833 7.88999 11.2899L13.82 5.36985C14.0113 5.20603 14.2574 5.12042 14.509 5.13014C14.7607 5.13986 14.9995 5.24419 15.1776 5.42229C15.3557 5.60038 15.46 5.83912 15.4697 6.0908C15.4794 6.34247 15.3938 6.58855 15.23 6.77985L9.99999 11.9999L15.21 17.2199C15.3962 17.4072 15.5008 17.6607 15.5008 17.9249C15.5008 18.189 15.3962 18.4425 15.21 18.6299C15.0287 18.8098 14.7854 18.9136 14.53 18.9199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.5976659cca73bb9690a2605f8e74402f.svg";
export { ForwardRef as ReactComponent };